import types from '../types';

export const getTeamAppAction = (teamId) => ({
  type: types.GET_TEAM_APP_START,
  payload: teamId,
});

export const clearTeamAppAction = () => ({
  type: types.CLEAR_TEAM_APP,
});
